export const forbiddenPageRoute = 'forbidden';
export const internalServerErrorPageRoute = 'internal-server-error';
export const sessionExpirePageRoute = 'session-expire';
